import { render } from "./ResetPasswordView.vue?vue&type=template&id=0185cca2"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0185cca2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0185cca2', script)) {
    api.reload('0185cca2', script)
  }
  
  module.hot.accept("./ResetPasswordView.vue?vue&type=template&id=0185cca2", () => {
    api.rerender('0185cca2', render)
  })

}

script.__file = "src/views/auth/ResetPasswordView.vue"

export default script